import pick from 'lodash/pick'
import * as moment from 'moment'
import storage from 'store'

import { SELECTED_CYCLE_ID } from '@/constants/store-key'
import {
  SET_USER,
  SET_USERS,
  SET_CYCLE,
  SELECT_CYCLE,
  SELECT_CYCLE_YEAR,
  ADD_USERS,
  SET_MENU
} from './mutation-types'

export default {
  [SET_USER] (state, user) {
    state.user = user
  },
  [SET_USERS] (state, users) {
    state.users = users.filter(user => !!user.mainDepartmentId).map(user => ({
      ...user,
      uid: user.id,
      mainDepartmentId: {
        ...user.mainDepartmentId,
        displayName: user.mainDepartmentId.completeName
      }
    }))
    users.forEach(user => {
      state.userMap[user.id] = pick(user, ['name', 'nickname'])
    })
  },
  [ADD_USERS] (state, user) {
    state.users.splice(state.users.length, 0, user)
    state.userMap[user.id] = pick(user, ['name', 'nickname'])
  },
  [SET_CYCLE] (state, { cycles, defaultCycleId }) {
    if (!defaultCycleId) {
      defaultCycleId = storage.get(SELECTED_CYCLE_ID)
    }
    const yearObj = {}
    cycles.forEach(cycle => {
      let year
      try {
        year = cycle.name.split('-')[0]
      } catch (e) {
        throw new Error(`周期名称是${cycle.name}，不是合法的格式[year-quarter]!`)
      }

      if (cycle.name.split('-')[1] === '全年') {
        cycle.displayName = year
        cycle.isFullYear = true
      }

      if (yearObj[year]) {
        yearObj[year].push(cycle)
      } else {
        yearObj[year] = [cycle]
      }
    })

    state.yearCycles = Object.values(yearObj)
    state.activeYearIndex = state.yearCycles.length - 1
    state.selectedCycleId = state.yearCycles[state.activeYearIndex][0].id

    // 默认选择当前时间所在的周期
    for (let yearIndex = state.yearCycles.length - 1; yearIndex >= 0; yearIndex--) {
      const cycles = state.yearCycles[yearIndex]
      for (let cycleIndex = cycles.length - 1; cycleIndex >= 0; cycleIndex--) {
        const cycle = cycles[cycleIndex]
        if (defaultCycleId) {
          if (defaultCycleId === cycle.id) {
            state.activeYearIndex = yearIndex
            state.selectedCycleId = cycle.id
            return
          }
        }
      }
      for (let cycleIndex = cycles.length - 1; cycleIndex >= 0; cycleIndex--) {
        const cycle = cycles[cycleIndex]
        if (moment().isAfter(cycle.fromDate) && moment().isBefore(cycle.toDate)) {
          state.activeYearIndex = yearIndex
          state.selectedCycleId = cycle.id
          return
        }
      }
    }
  },
  [SELECT_CYCLE] (state, id) {
    state.selectedCycleId = id
    storage.set(SELECTED_CYCLE_ID, id)
  },
  [SELECT_CYCLE_YEAR] (state, isNext) {
    if (isNext) {
      const cycles = state.yearCycles[++state.activeYearIndex]
      state.selectedCycleId = cycles[0].id
    } else {
      const cycles = state.yearCycles[--state.activeYearIndex]
      state.selectedCycleId = cycles[cycles.length - 1].id
    }
  },
  [SET_MENU] (state, menu) {
    state.menu.selectedKeys = menu.selectedKeys
    if (menu.parentKeys) {
      state.menu.openKeys = menu.parentKeys
    }
  }
}
